<template>
  <html>
    <MenuApp />
    <div class="container">
      <h1>Paiement Annulé</h1>
      <p>
        Le paiement que vous avez tenté d'effectuer a été annulé. Veuillez
        vérifier vos informations ou réessayer plus tard.
      </p>
    </div>
  </html>
</template>

<script>
import MenuApp from "./MenuApp.vue";
export default {
  name: "PaymentsCancelled",
  components: { MenuApp },
};
</script>

<style scoped>
.page {
  text-align: center;
  padding: 20px;
}
</style>
